import React from 'react';
import Loader from './ui/Loader';

export default function ContentLoading (): React.ReactElement {
  return (
    <section className="section">
      <div className="container">
        <div className="columns is-centered">
          <div className="column is-9-widescreen is-11-tablet">
            <div className="rows">
              <div className="row has-text-centered">
                <h1 className="headline is-level-2">Suivi de dossier</h1>
                <Loader marginTop="60px"
                  marginBottom="60px"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}